import { useNavigate, useParams } from "react-router-dom";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import RefreshLineIcon from "remixicon-react/RefreshLineIcon";
import AttributeListingForm from "../../components/AttributeListing/AttributeListingForm";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import {
  getAttributeById,
  setAttribute,
} from "../../../core/actionCreators/attributeActionCreator";

const AttributeListing = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formRef = useRef<any>(null);
  const backArrowClickHadler = () => {
    navigate("/attributeListing");
  };

  const [pageMode, setPageMode] = useState("");
  const { attribute } = useSelector((s: any) => s.attributeStore);

  const [refreshedCount, setRefreshedCount] = useState<number | null>(null);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath === "/attributeListing/create") {
      setPageMode("CREATE");
    } else {
      if (params.id) {
        setPageMode("EDIT");
        dispatch(getAttributeById(params.id, null));
      }
    }
    return () => {
      dispatch(setAttribute({}));
      setRefreshedCount(null);
    };
  }, [params, window]);

  return (
    <>
      <div className="flex mainWrapper w-full">
        <div className="sidenav-wrapper">
          <SideNavbar />
        </div>
        <div className="right-container">
          <div className="header-container">
            <Header />
          </div>
          <div className="body-container">
            <div className="Subheader bg-white p-[15px] shadow-[0_2px_6px_rgba(0,0,0,.1)]">
              <div className="flex items-center w-full">
                <ArrowLeftSLineIcon
                  onClick={backArrowClickHadler}
                  size={24}
                  className="mr-4 cursor-pointer"
                />
                <p className="text-xl font-bold text-[#43425D] flex items-center">
                  {pageMode === "CREATE" ? "Create" : "Update"} Attribute Listing
                </p>
                {pageMode === "EDIT" && attribute.productCount !== undefined && (
                  <div className="ml-auto flex items-center gap-4">
                    <div className="flex flex-col items-end">
                      <span className="text-[10px] uppercase tracking-wider font-semibold text-[#8E8E8E]">
                        Original Count
                      </span>
                      <span className="text-sm font-bold text-[#43425D]">
                        {attribute.productCount}
                      </span>
                    </div>
                    
                    {refreshedCount !== null && refreshedCount !== attribute.productCount && (
                      <div className="flex items-center">
                        <div className="h-8 w-[1px] bg-[#EAEAEA] mx-2"></div>
                        <div className="flex flex-col items-start">
                          <span className="text-[10px] uppercase tracking-wider font-semibold text-[#3B86FF]">
                            Refreshed
                          </span>
                          <span className={`text-sm font-bold ${refreshedCount > attribute.productCount ? 'text-green-500' : refreshedCount < attribute.productCount ? 'text-red-500' : 'text-[#3B86FF]'}`}>
                            {refreshedCount}
                            {refreshedCount > attribute.productCount ? ' ↑' : refreshedCount < attribute.productCount ? ' ↓' : ''}
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="bg-[#3B86FF] text-white px-4 py-1 rounded-md text-sm font-bold shadow-[0_2px_4px_rgba(59,134,255,0.2)] flex items-center gap-2">
                       {refreshedCount !== null ? refreshedCount : attribute.productCount}
                       <RefreshLineIcon 
                         size={16} 
                         className="cursor-pointer hover:rotate-180 transition-transform duration-500" 
                         onClick={() => formRef.current?.checkProductCount()}
                       />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <AttributeListingForm 
              ref={formRef}
              pageMode={pageMode} 
              attribute={attribute} 
              onCountUpdate={(count: number) => setRefreshedCount(count)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default AttributeListing;
